import { styles } from 'themes/css/acclimaterra.style.js';

const cssTable = {
  'Sciences, Climat & Territoires': styles,
};

export const getCorrectThemeCss = (name) => {
  return cssTable[name];
};
